<template>
	<form @submit.prevent="submit" enctype="multipart/form-data" ref="form">
        <!-- <div class="modal-card" style="min-width: 500px"> -->
        	<div v-if="logo_path" style="text-align:center;">
        		<img :src="logo_path" style="max-width:200px;">
        	</div>
			<b-field label="Logo">
				<b-upload v-model="form.logo" accept="image/*">
					<b-button icon-left="upload" tag="a">
						<span>{{ form.logo ? form.logo.name : "Choose File" }}</span>
					</b-button>
				</b-upload>
			</b-field> 
            <b-field label="Sub Domain">
                <b-input type="text" v-model="form.subdomain" required></b-input>
            </b-field>
            <b-field label="Long Name">
                <b-input type="text" v-model="form.long_name" required></b-input>
            </b-field>
            <b-field label="Short Name">
                <b-input type="text" v-model="form.short_name" required></b-input>
            </b-field>
            <b-field label="Color">
                <b-input type="text" v-model="form.color" required></b-input>
            </b-field>
            <b-field label="Black or White">
                <b-input type="text" v-model="form.b_or_w" required></b-input>
            </b-field>

            <div class="field">
                <b-checkbox v-model="form.registration">Registration</b-checkbox>
            </div>

            <button class="button is-primary">Save</button>
        <!-- </div> -->
    </form>
</template>
<script>
import { PortalService } from "@/services/portal.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
export default {
	props: [ 'portal', 'model' ],
    data: () => ({
    	logo_path: null,
    	form: {
    		subdomain: '',
    		long_name: '',
    		short_name: '',
    		color: '',
    		b_or_w: '',
    		logo: null,
            firm_id: '',
            registration: false,
    	},
    }),
    watch: {
        portal() {
            this.generateFormData();
        }
    },
    methods: {
    	submit() {
            if (this.portal) {
    			PortalService.update(this.portal.id, this.transformedData()).then(response => {
                    this.$emit('update:portal', JsonDenormalizer.denormalize(response));
    				this.$buefy.toast.open({
    					message: "Portal Updated",
    					type: "is-success",
    					position: "is-top-right"
    		        });
    			})
            } else {
                PortalService.store(this.transformedData()).then(response => {
                    this.$emit('update:portal', JsonDenormalizer.denormalize(response));
                    this.$buefy.toast.open({
                        message: "Portal Created",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
            }
		},
		generateFormData() {
            this.form.subdomain    = this.portal ? this.portal.subdomain : '';
            this.form.registration = this.portal ? (this.portal.registration == '1' ? true: false) : false;
            this.form.long_name    = this.portal ? this.portal.long_name : '';
            this.form.short_name   = this.portal ? this.portal.short_name : '';
            this.form.color        = this.portal ? this.portal.color : '';
            this.form.b_or_w       = this.portal ? this.portal.b_or_w : '';
            this.logo_path         = this.portal && this.portal.logo ? this.portal.logo.path : '';
            this.form.logo         = null;
		},
		transformedData() {
			let formData = new FormData(this.$refs.form);
            formData.append("file", this.form.logo);
			formData.append("registration", this.form.registration ? 1 : 0);
			formData.append("subdomain", this.form.subdomain);
			formData.append("long_name", this.form.long_name);
			formData.append("short_name", this.form.short_name);
			formData.append("color", this.form.color);
            formData.append("b_or_w", this.form.b_or_w);
			formData.append("firm_id", this.model.id);
			return formData;
	    },
    },
    mounted() {
    	this.generateFormData();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Portals/partials/organizationPortalForm.vue